module.exports = __webpack_public_path__ + "static/media/tpl.0acf02bf.svg";